const OFFICIAL_REMINDER_TRANSLATIONS = {
  "3 attacks": "3次攻击",
  "3 votes": "3票",
  "Ability twice": "能力两次",
  Abnormal: "异常",
  "About to die": "即将死亡",
  Alive: "存活",
  Amigo: "朋友",
  "At a sermon": "布道中",
  "Attack 1": "攻击1",
  "Attack 2": "攻击2",
  "Attack 3": "攻击3",
  "Can not die": "不会死亡",
  "Can not nominate": "不能提名",
  "Chose death": "选择死亡",
  "Chose life": "选择生命",
  Chosen: "已选择",
  Claimed: "已宣称",
  Correct: "正确",
  Cursed: "被诅咒",
  "Day 1": "第1天",
  "Day 2": "第2天",
  "Day 3": "第3天",
  "Day 4": "第4天",
  "Day 5": "第5天",
  Dead: "死亡",
  Demon: "恶魔",
  "Demon not voted": "恶魔未投票",
  "Demon voted": "恶魔已投票",
  "Died today": "今日死亡",
  Drunk: "醉酒",
  "Drunk 1": "醉酒1",
  "Drunk 2": "醉酒2",
  "Drunk 3": "醉酒3",
  "Everyone drunk": "全员醉酒",
  "Evil wakes": "邪恶唤醒",
  Executed: "已处决",
  Fear: "恐惧",
  "Good player executed": "善良玩家被处决",
  Grandchild: "孙辈",
  "Guess used": "猜测已用",
  "Haircuts tonight": "今晚理发",
  "Has ability": "有能力",
  "Is the Alchemist": "是炼金术士",
  "Is the Apprentice": "是学徒",
  "Is the Demon": "是恶魔",
  "Is the Marionette": "是提线木偶",
  "Is the Philosopher": "是哲学家",
  Known: "已知",
  Knows: "知晓",
  Mad: "疯狂",
  Master: "主人",
  Minion: "爪牙",
  "Minion nominated": "爪牙已提名",
  "Minions not nominated": "爪牙未被提名",
  "Negative vote": "负票",
  "No ability": "无能力",
  "Nominate evil": "提名邪恶",
  "Nominate good": "提名善良",
  "Not Me": "不是我",
  Once: "一次",
  Outsider: "外来者",
  Poisoned: "中毒",
  Protected: "保护",
  "Red herring": "干扰项",
  Seen: "已看见",
  "Seen Demon": "看见恶魔",
  "Seen Minion": "看见爪牙",
  "Seen Outsider": "看见外来者",
  "Seen Townsfolk": "看见镇民",
  "Seen Traveller": "看见旅行者",
  "Sober & Healthy": "清醒健康",
  "Survives execution": "处决存活",
  Townsfolk: "镇民",
  "Turns evil": "转为邪恶",
  Twin: "双生",
  Wrong: "错误",
};

function translateOfficialReminder(reminder) {
  if (typeof reminder !== "string") return reminder;
  return OFFICIAL_REMINDER_TRANSLATIONS[reminder] || reminder;
}

function translateOfficialReminders(reminders) {
  return Array.isArray(reminders)
    ? reminders.map(translateOfficialReminder)
    : reminders;
}

module.exports = {
  translateOfficialReminder,
  translateOfficialReminders,
};
